{
  "name": "gas-te-web",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng lint && ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "lintFix": "ng lint --fix",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "^22.2.4",
    "@angular/animations": "^22.2.3",
    "@angular/cdk": "^22.2.4",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/localize": "^22.2.3",
    "@angular/material": "^22.2.4",
    "@angular/material-moment-adapter": "^22.2.4",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@ngbracket/ngx-layout": "^16.1.3",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@siemens/ngx-datatable": "^22.4.1",
    "@swimlane/ngx-charts": "^20.1.0",
    "@swimlane/ngx-datatable": "^20.1.0",
    "angular-calendar": "^0.28.26",
    "bootstrap": "^5.3.3",
    "chart.js": "^4.0.0",
    "chartist": "^0.11.4",
    "core-js": "3.15.2",
    "date-fns": "^2.22.1",
    "jquery": "^3.6.0",
    "jwt-decode": "^3.1.2",
    "lodash": "^4.17.21",
    "moment": "^2.29.1",
    "ng-chartist": "^5.0.0",
    "ng-multiselect-dropdown": "1.0.0",
    "ng2-charts": "6.0.1",
    "ng2-completer": "^9.0.1",
    "ng2-dragula": "2.1.1",
    "ng2-file-upload": "1.4.0",
    "ngx-perfect-scrollbar": "10.1.1",
    "ngx-toastr": "^20.0.5",
    "rxjs": "^7.8.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.2.4",
    "@angular-eslint/builder": "^16.3.1",
    "@angular-eslint/eslint-plugin": "^16.3.1",
    "@angular-eslint/eslint-plugin-template": "^16.3.1",
    "@angular-eslint/schematics": "^17.5.1",
    "@angular-eslint/template-parser": "^16.3.1",
    "@angular/cli": "^22.2.4",
    "@angular/compiler-cli": "^22.2.3",
    "@angular/language-service": "^22.2.3",
    "@types/chartist": "0.11.1",
    "@types/jasmine": "~3.8.1",
    "@types/jasminewd2": "~2.0.10",
    "@types/jquery": "^3.5.6",
    "@types/node": "^22.20.5",
    "@typescript-eslint/eslint-plugin": "5.16.0",
    "@typescript-eslint/parser": "5.16.0",
    "d3": "^7.3.0",
    "d3-array": "^3.1.1",
    "d3-brush": "^3.0.0",
    "d3-color": "^3.0.1",
    "d3-force": "^3.0.0",
    "d3-format": "^3.1.0",
    "d3-hierarchy": "^3.1.1",
    "d3-interpolate": "^3.0.1",
    "d3-scale": "^4.0.2",
    "d3-selection": "^3.0.0",
    "d3-shape": "^3.1.0",
    "d3-time-format": "^4.1.0",
    "eslint": "^7.26.0",
    "eslint-plugin-import": "^2.25.4",
    "eslint-plugin-jsdoc": "^38.0.4",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~3.8.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.3.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-cli": "~2.0.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~4.0.1",
    "karma-jasmine-html-reporter": "^1.7.0",
    "protractor": "~7.0.0",
    "ts-node": "~10.1.0",
    "typescript": "~6.0.3"
  }
}
